import { AxiosResponse } from 'axios';

import { API } from '../../utils/axios';

export interface ConfigValue {
  statusCode: number;
  message: string;
  resource: Resource[];
}

export interface Resource {
  id: number;
  config_type: string;
  service_type: string;
  config_value: any;
}

class ConfigService {
  static getConfigValues(serviceType: string, configType = 'picker') {
    return API.get<any, AxiosResponse<ConfigValue>>(
      `v1/auth/config_values?serviceType=${serviceType}&configType=${configType}`,
    ).then((res) => res.data);
  }
}

export default ConfigService;
